export default "__VITE_ASSET__Dfvq8tXy__"